import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig } from '@angular/material'

import * as _ from "lodash";
import { Route } from '@angular/router';
import { TransformerManagerService } from '../../services/transformerManager.service';
import * as moment from 'moment';
import { ReportService } from '../../services/report.service';

@Component({
  selector: 'app-detection-report',
  templateUrl: './detection-report.component.html',
  styleUrls: ['./detection-report.component.scss']
})
export class DetectionReportComponent implements OnInit {
  reportColumns: any;
  heading: any=[];
  dataSource;
  typeFilter: any;
  data: any;
  filter: any ={};
  transformerList: any = [];
  transformerDetail;
  selectedTransformer = null;
  isDataSource = false;

  isNotCustomDate=true;
  showDateRange = false;
  selectedDate;
  dateName = 'Today';
  currentUserData = JSON.parse(localStorage.getItem('userData'));

  durationList = [
    { id: 1, name: 'Today' },
    { id: 2, name: 'Yesterday' },
    { id: 3, name: 'This Week' },
    { id: 4, name: 'This Month' },
    { id: 5, name: 'Last Month' },
    { id: 6, name: 'Custom' }
  ];
  selectedDuration = this.durationList[0];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
   private ngxLoader: NgxUiLoaderService, private transMngSer: TransformerManagerService, private reportService: ReportService) { }

  ngOnInit() {
    this.getDdlData();
        
  }

  transformerSelection(selectedTransformer){
    this.selectedTransformer = selectedTransformer;
    console.log('selected transformer',selectedTransformer);
    this.backendCall();
   
  }

  backendCall(){
    this.dataSource = [];
    console.log('device id and date', this.selectedTransformer.deviceId, this.dateName)
    this.reportService.getObjectReport({"deviceid": this.selectedTransformer.deviceId, "duration": this.dateName}).subscribe((response:any) => {
      console.log("response", response)
      if(response.code ==1 && response.result.length > 0){
        this.isDataSource = true;
        this.dataSource = response.result;
        this.dataSource = this.dataSource.map(item => {
          delete item.id;
          delete item.gdate;
          return item; // Return the modified object
        });
        this.heading = Object.keys(this.dataSource[0]);
        this.dataSource = new MatTableDataSource(this.dataSource);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        console.log('headings', this.heading)
        console.log('dataSource',this.dataSource);
      } else {
        this.isDataSource = false;
      }
    })
  }

  getDdlData() {
    
    this.transMngSer.getTransformerData(JSON.parse(localStorage.getItem('userData')).roleid, JSON.parse(localStorage.getItem('userData')).userid, 'report').subscribe((response:any)=> {
      if (response && response.code === '1' && response.data.length > 0) {
        this.transformerList = response.data.map((a:any) => {
          a.transformerDetail = a.serialnumber + "[" + a.sitename + "]";
          return a;
        })
        console.log("transformer list",this.transformerList)
        if(this.selectedTransformer == null){
          this.selectedTransformer = this.transformerList[0];
        }
      }
      this.backendCall();

    })
}

durationSelectionAlert(selectedDuration) {
  console.log('selectedDuration====', selectedDuration);
  this.dateName = selectedDuration.name;
  if (selectedDuration.id == 6) {
    this.showDateRange = true;
    this.isNotCustomDate = false;
  } else {
    this.showDateRange = false;
    this.backendCall();
  }
  //this.selectedDate = date;
  //this.dateName = selectedDuration.name;

  console.log('date name:', this.dateName)
  
}

changeDateRange(event) {
  console.log("event----------", event)
  if (this.showDateRange) {
    let date = {
      startdate: moment(event.value[0]).format('YYYY-MM-DD'),
      enddate: moment(event.value[1]).format('YYYY-MM-DD')
    };
    this.isNotCustomDate=true;
    this.selectedDate = date;
    this.dataSource = [];
    this.reportService.getObjectReport({"deviceid": this.selectedTransformer.deviceId, "duration": this.dateName, startDate: date.startdate, endDate: date.enddate}).subscribe((response: any) =>{
      if(response.code ==1 && response.result.length > 0){
        console.log('response', response);
        this.isDataSource = true;
        this.dataSource = response.result;
        this.dataSource = this.dataSource.map(item => {
          delete item.id;
          delete item.gdate;
          return item; // Return the modified object
        });
        this.heading = Object.keys(this.dataSource[0]);
        this.dataSource = new MatTableDataSource(this.dataSource);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        console.log('headings', this.heading)
        console.log('dataSource',this.dataSource);
      } else {
        this.isDataSource = false;
      }
    })
  }
  console.log('date', this.selectedDate);


}
}
